
import { Link } from 'react-router-dom';
import MotionWrapper from '../../../components/base/MotionWrapper';

const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-settings-3-line',
      title: 'Workflow System Architecture',
      description: 'Clean, scalable workflow design to eliminate bottlenecks, reduce manual steps, and improve operational efficiency.',
      link: '/services/workflow-system-architecture'
    },
    {
      icon: 'ri-user-add-line',
      title: 'Lead & Client Intake Systems',
      description: 'Automated intake pipelines that capture, qualify, route, and schedule new leads without manual follow-up.',
      link: '/services/intake-automation'
    },
    {
      icon: 'ri-database-2-line',
      title: 'CRM Process Automation',
      description: 'Integrated CRM workflows that centralize data, automate updates, and keep teams aligned in real time.',
      link: '/services/crm-automation'
    },
    {
      icon: 'ri-robot-line',
      title: 'NextPhase Concierge AI™',
      description: 'AI-powered organizational assistant trained on your workflow documents, language, and procedures to support staff & clients.',
      link: '/services/concierge-ai'
    }
  ];

  return (
    <section 
      id="services" 
      className="py-20 lg:py-28"
      style={{ backgroundColor: '#F8F4EF' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <MotionWrapper className="text-center mb-16">
          <h2 
            className="text-4xl lg:text-5xl font-bold mb-6"
            style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
          >
            Our Core Automation Services
          </h2>
          <p 
            className="text-xl lg:text-2xl leading-relaxed max-w-4xl mx-auto"
            style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
          >
            Modern operational systems designed to remove manual work, unlock scale, and improve clarity across your entire organization.
          </p>
        </MotionWrapper>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8 lg:gap-12">
          {services.map((service, index) => (
            <MotionWrapper 
              key={service.title}
              delay={index * 80}
              className="motion-hover-card bg-white rounded-2xl p-8 lg:p-10 border-2 transition-all duration-200"
              style={{ borderColor: '#E6DACD' }}
            >
              <div className="mb-6">
                <div 
                  className="w-16 h-16 rounded-xl flex items-center justify-center mb-6"
                  style={{ backgroundColor: '#F8F4EF' }}
                >
                  <i 
                    className={`${service.icon} text-2xl`}
                    style={{ color: '#7B6655' }}
                  ></i>
                </div>
                <h3 
                  className="text-2xl lg:text-3xl font-bold mb-4"
                  style={{ color: '#2B2B2B', fontFamily: 'Manrope, Inter, sans-serif' }}
                >
                  {service.title}
                </h3>
                <p 
                  className="text-lg leading-relaxed mb-8"
                  style={{ color: '#2B2B2B', fontFamily: 'Inter, sans-serif' }}
                >
                  {service.description}
                </p>
              </div>
              
              <Link
                to={service.link}
                className="motion-hover-button inline-flex items-center px-8 py-3 rounded-lg font-semibold text-white whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#7B6655', fontFamily: 'Manrope, Inter, sans-serif' }}
              >
                Learn More
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </MotionWrapper>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
